import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

import { FinnairBoundFareFamily } from '@fcom/dapi/api/models';

@Injectable()
export class DimensionsAndDetailsModalService {
  get showDimensionsAndDetailsObservable$(): Observable<FinnairBoundFareFamily> {
    return this.showDimensionsAndDetails$;
  }

  get showAllDimensionsAndDetailsObservable$(): Observable<boolean> {
    return this.showAllDimensionsAndDetails$;
  }

  private showDimensionsAndDetails$: BehaviorSubject<FinnairBoundFareFamily> =
    new BehaviorSubject<FinnairBoundFareFamily>(undefined);
  private showAllDimensionsAndDetails$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  opedDimensionsAndDetails(bound: FinnairBoundFareFamily): void {
    this.showDimensionsAndDetails$.next(bound);
  }

  opedAllDimensionsAndDetails(): void {
    this.showAllDimensionsAndDetails$.next(true);
  }

  closeModal(): void {
    this.showDimensionsAndDetails$.next(undefined);
    this.showAllDimensionsAndDetails$.next(false);
  }
}
